var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_2168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.078125 1.88516C0.078125 1.90742 3.46636 6.11563 7.61538 11.2441C11.7566 16.3727 15.1291 20.6105 15.1134 20.6551C15.0899 20.707 11.9213 24.1508 8.06244 28.3219C4.21146 32.4855 1.01146 35.9516 0.948713 36.0184C0.846753 36.1371 1.04283 36.1445 3.91342 36.1445H6.98009L12.486 30.1773C15.5213 26.8895 18.0154 24.2027 18.0389 24.2027C18.0624 24.1953 20.2507 26.882 22.9017 30.1699L27.7252 36.1371L33.9056 36.1445C37.3017 36.1445 40.0781 36.1297 40.0781 36.1074C40.0781 36.0926 36.533 31.6395 32.2036 26.2215L24.3213 16.3652L24.5409 16.1426C24.6664 16.0164 27.6154 12.8324 31.0977 9.05469C34.5801 5.27695 37.5056 2.11523 37.5919 2.01875L37.7487 1.85547L34.6585 1.86289H31.5683L26.5487 7.31055C23.7879 10.309 21.5134 12.7582 21.4899 12.7656C21.4664 12.7656 19.4899 10.309 17.0977 7.31055L12.7448 1.86289L6.41538 1.85547C2.92518 1.85547 0.078125 1.87031 0.078125 1.88516ZM21.8036 18.8219C27.8193 26.3551 32.7605 32.5523 32.7683 32.5895C32.784 32.6266 32.1173 32.6562 31.1134 32.6562H29.435L18.384 18.9852C12.3056 11.4668 7.30165 5.26953 7.27028 5.21758C7.21538 5.13594 7.54479 5.12109 9.03499 5.12109L10.8624 5.12852L21.8036 18.8219Z",
    fill: "#F1E1C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_2168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.982c25fd0f54ebf4fceb6fdf0bd19c8b.svg";
export { ForwardRef as ReactComponent };